export const strings = {
  no_surveys: 'No surveys available',
  wait: 'Please Wait....',
};
